import CoreBase from '../../../../services/engines/CoreBase';
import AppContext from '../../../../controllers/AppContext';
import userTopicService from '../../../../services/UserTopicService';
import responseHelper from '../../../../services/ResponseHelper';

const _1MB = 1024 * 1024;

class EntryUpdater extends CoreBase {
    _name = 'EntryUpdater';

    /**
     * Persists updated body back to BE.
     * Serializes body object via JSON.stringify — use savePlainTextBody for raw strings.
     * @param {object} entry
     * @param {object} body
     */
    async update(entry, body) {
        const jwt = AppContext.getToken();
        if (!entry?.rk || !jwt) return;

        const serialized = JSON.stringify(body);
        if (new Blob([serialized]).size > _1MB) return;

        const resp = await userTopicService.updateJournalBody(entry.rk, serialized);
        const code = responseHelper.check(resp, 'update', this._name);
        if (code < 0) this.logError(`update: response code: ${code}`);
    }

    /**
     * Persists a plain text or JSON string body directly to BE.
     * Unlike update(), does not JSON.stringify — sends body as-is.
     * @param {object} entry
     * @param {string} body - raw string (plain text or JSON)
     */
    async savePlainTextBody(entry, body) {
        const jwt = AppContext.getToken();
        if (!entry?.rk || !jwt) return false;

        if (new Blob([body]).size > _1MB) return false;

        const resp = await userTopicService.updateJournalBody(entry.rk, body);
        const code = responseHelper.check(resp, 'savePlainTextBody', this._name);
        if (code > 0) return true;

        this.logError(`savePlainTextBody: response code: ${code}`);
        return false;
    }
}

const entryUpdater = new EntryUpdater();
export default entryUpdater;
